import '../sections/section-newsletter';
import '../../sass/layout/page/page-simple.scss';